var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#464655"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#C8414B"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 161.68,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 26.947
  }), /*#__PURE__*/React.createElement("rect", {
    y: 323.37,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 26.947
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M328.146,142.469c10.85-22.371,22.169-74.194,22.169-74.194s-33.69,40.973-44.54,63.344   c-2.274,4.689-1.31,10.081,1.976,13.729l-123.58,254.794l8.389,4.069l123.581-254.794   C321.04,149.739,325.872,147.158,328.146,142.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M183.854,142.469c-10.85-22.371-22.169-74.194-22.169-74.194s33.69,40.973,44.54,63.344   c2.274,4.689,1.31,10.081-1.976,13.729L327.83,400.142l-8.389,4.069L195.859,149.417   C190.96,149.739,186.128,147.158,183.854,142.469z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8414B"
    },
    d: "M323.368,256c0,74.413-54.966,134.737-67.368,134.737S188.632,330.413,188.632,256  S243.598,121.263,256,121.263C268.402,121.263,323.368,181.587,323.368,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M309.895,321.007c7.937-19.28,13.474-41.424,13.474-65.007s-5.537-45.727-13.474-65.007   c-7.937,19.28-13.474,41.424-13.474,65.007S301.958,301.727,309.895,321.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M202.105,190.993c-7.937,19.28-13.474,41.424-13.474,65.007s5.537,45.727,13.474,65.007   c7.937-19.28,13.474-41.424,13.474-65.007S210.042,210.273,202.105,190.993z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 256,
    cy: 256,
    rx: 13.474,
    ry: 20.21
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M258.021,121.263v114.526c3.674-7.647,10.189-30.243,10.189-57.263   C268.211,151.504,261.695,128.91,258.021,121.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M253.979,121.263c-3.674,7.647-10.189,30.241-10.189,57.263c0,27.02,6.516,49.616,10.189,57.263   V121.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M258.021,276.211v114.526c3.674-7.647,10.189-30.243,10.189-57.263   C268.211,306.452,261.695,283.857,258.021,276.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M253.979,276.211c-3.674,7.647-10.189,30.241-10.189,57.263c0,27.02,6.516,49.616,10.189,57.263   V276.211z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKe);
export default __webpack_public_path__ + "static/media/KE.06749594150d5d05639c77a84625318d.svg";
export { ForwardRef as ReactComponent };